import React from 'react';
import PropTypes from 'prop-types';
import ProjectStatusLabel from '../ProjectStatusLabel';

const defaultFunc = () => null;

const renderLabel = (labelType, copy) => <span className={`badge rounded-pill bg-${labelType} ms-2 px-6`}>{copy}</span>;

const renderEmploymentTypeBadge = (type) => {
  switch (type) {
    case 'full_time':
      return renderLabel('warning', 'Full Time');
    case 'consulting':
      return renderLabel('default', 'Consulting');
    default:
      return null;
  }
};

const renderTypeBadge = (type) => {
  switch (type) {
    case 'latent_demand':
      return renderLabel('success', 'Latent Demand');
    case 'request':
      return renderLabel('info', 'Request');
    case 'replacement':
      return renderLabel('default', 'Replacement');
    case 'open_marketplace':
      return renderLabel('warning', 'OM');
    case 'extension':
      return renderLabel('info', 'Extension');
    default:
      return null;
  }
};

function ProjectIndexRow({
  name,
  projectLink,
  owner,
  ownerLink,
  company,
  companyLink,
  timestamp,
  daysOpen,
  status,
  numProposals,
  firstProposalSubmittedAt,
  numInterests,
  mostRecentInterestTimestamp,
  editLink,
  editable,
  specialFieldsLink,
  isPublic,
  type,
  callback,
  index,
  assignedRep,
  employmentType,
  showEmploymentType,
}) {
  return (
    // <div className="row d-flex align-items-center d-sm-block text-sm-center">
    <div className="d-sm-flex text-center text-sm-start">
      <div className="col-sm-6 col-md-4">
        <h4 className="mt-0 mb-0">
          <a href={projectLink} target="_blank" className="admin-project-show" rel="noreferrer">{name}</a>
          { isPublic && renderLabel('primary', 'Public') }
          { renderTypeBadge(type) }
          { showEmploymentType && renderEmploymentTypeBadge(employmentType) }
        </h4>
        <h5 className="mt-0 mb-0">
          <small className="fs-hide">
            <a href={ownerLink} className="fs-hide project-owner">{owner}</a>
          &nbsp;&bull;&nbsp;
            <a href={companyLink} className="company-name">{company}</a>
          </small>
        </h5>
        <h6 className="mt-0 mb-0">
          <small>
            {timestamp}
            {' '}
&nbsp;&bull;&nbsp;
            {' '}
            {daysOpen}
            {' '}
            Days Opened
          </small>
        </h6>
      </div>

      <div className="col-sm-6 col-md-3">
        <ProjectStatusLabel status={status} />
        {assignedRep && assignedRep.name}
      </div>

      <div className="col-sm-6 col-md-1">
        {numProposals}
        {' '}
        Proposal(s)
        <h5 className="mt-0 mb-0">
          <small>
            {firstProposalSubmittedAt}
          </small>
        </h5>
      </div>

      <div className="col-sm-6 col-md-1">
        {numInterests}
        {' '}
        Resume(s)
        <h5 className="mt-0 mb-0">
          <small>
            {mostRecentInterestTimestamp}
          </small>
        </h5>
      </div>

      <div className="col-sm-6 col-md-3 ">
        { editable
          ? <a href={editLink} className="btn btn-small btn-default me-2">Edit</a>
          : null}
        { status === 'employer_draft'
          ? (
            <button
              className="btn btn-small btn-primary me-2"
              value={index}
              onClick={callback}
            >
              Request Matching
            </button>
          )
          : null}
        { status === 'employer_requested_matching'
          ? (
            <button
              className="btn btn-small btn-info"
              value={index}
              onClick={callback}
            >
              Begin Matching
            </button>
          )
          : null}

        <div className="btn-group float-end">
          <button
            type="button"
            className="btn btn-default more-menu dropdown-toggle"
            data-bs-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          />
          <ul className="dropdown-menu">
            <li><a className="dropdown-item" href={specialFieldsLink}>Change Owner</a></li>
            <li><a className="dropdown-item" href={specialFieldsLink}>Status Change Tracking</a></li>
          </ul>
        </div>
      </div>
    </div>
  );
}

ProjectIndexRow.propTypes = {
  name: PropTypes.string.isRequired,
  projectLink: PropTypes.string.isRequired,
  owner: PropTypes.string.isRequired,
  ownerLink: PropTypes.string.isRequired,
  company: PropTypes.string,
  companyLink: PropTypes.string,
  timestamp: PropTypes.string.isRequired,
  daysOpen: PropTypes.number.isRequired,
  status: PropTypes.string.isRequired,
  numProposals: PropTypes.number.isRequired,
  firstProposalSubmittedAt: PropTypes.string,
  numInterests: PropTypes.number.isRequired,
  mostRecentInterestTimestamp: PropTypes.string,
  editable: PropTypes.bool.isRequired,
  editLink: PropTypes.string,
  specialFieldsLink: PropTypes.string,
  isPublic: PropTypes.bool.isRequired,
  type: PropTypes.string,
  callback: PropTypes.func,
  index: PropTypes.number.isRequired,
  assignedRep: PropTypes.shape({}),
  employmentType: PropTypes.string.isRequired,
  showEmploymentType: PropTypes.bool,
};

ProjectIndexRow.defaultProps = {
  company: null,
  companyLink: null,
  editLink: null,
  firstProposalSubmittedAt: null,
  mostRecentInterestTimestamp: null,
  specialFieldsLink: null,
  type: '',
  callback: defaultFunc,
  assignedRep: {},
  showEmploymentType: false,
};

export default ProjectIndexRow;
